var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('el-card',{staticClass:"form-container",attrs:{"shadow":"never"}},[_c('notification-form',{attrs:{"type":"all"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }